<app-parallax-section
        backgroundImage="/assets/images/industry_overview/Architekten.webp"
        minHeight="400px"
>
    <section class="py-5 bg-transparent" >
        <div class="container">
            <div class="row justify-content-center mb-4">
                <div class="col-lg-8 text-center">
                    <h2 class="fw-bold text-white mb-2 display-6">
                        <span class="text-primary">Ihre Vorteile</span> auf einen Blick
                    </h2>
                </div>
            </div>
            <div class="row g-5 justify-content-center">
                <!-- PRO CARD -->
                <div class="col-lg-5">
                    <div class="pro-advantage-card position-relative h-100 border-0 shadow-lg rounded-4 overflow-hidden bg-white">
                        <div class="pro-ribbon position-absolute top-0 start-0 px-4 py-2 rounded-end-pill text-white fw-semibold fs-6"
                             style="background: linear-gradient(90deg,#19c37d,#2563eb); letter-spacing:1px; box-shadow:0 2px 8px rgba(25,195,125,0.07); z-index:10;">
                            <i class="fa fa-check-circle me-1"></i> PRO-Liste
                        </div>
                        <div class="p-4 pt-5 card-body-space">
                            <ul class="list-unstyled mb-0">
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient me-3"><i class="fa fa-bullseye fa-2x"></i></span>
                                    <span class="fs-5">Präzise Zielgruppenansprache<br><span class="text-secondary fs-6">Dank individueller Konfiguration</span></span>
                                </li>
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient me-3"><i class="fa fa-clock-o fa-2x"></i></span>
                                    <span class="fs-5">Zeitersparnis<br><span class="text-secondary fs-6">Direkte Filter nach Branche, Region, Keywords</span></span>
                                </li>
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient me-3"><i class="fa fa-trophy fa-2x"></i></span>
                                    <span class="fs-5">Wettbewerbsvorteil<br><span class="text-secondary fs-6">Daten, die andere nicht bieten</span></span>
                                </li>
                                <li class="mb-2 d-flex align-items-center">
                                    <span class="icon-gradient me-3"><i class="fa fa-credit-card fa-2x"></i></span>
                                    <span class="fs-5">Flexibles Zahlungsmodell<br><span class="text-secondary fs-6">Sicher via Überweisung oder PayPal</span></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- CONTRA CARD -->
                <div class="col-lg-5">
                    <div class="contra-advantage-card position-relative h-100 border-0 shadow-lg rounded-4 overflow-hidden bg-white">
                        <div class="contra-ribbon position-absolute top-0 start-0 px-4 py-2 rounded-end-pill text-white fw-semibold fs-6"
                             style="background: linear-gradient(90deg,#ff5c5c,#fba43a); letter-spacing:1px; box-shadow:0 2px 8px rgba(255,92,92,0.08); z-index:10;">
                            <i class="fa fa-times-circle me-1"></i> CONTRA (andere Anbieter)
                        </div>
                        <div class="p-4 pt-5 card-body-space">
                            <ul class="list-unstyled mb-0">
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient-red me-3"><i class="fa fa-exclamation-triangle fa-2x"></i></span>
                                    <span class="fs-5">Oft veraltete oder lückenhafte Listen</span>
                                </li>
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient-red me-3"><i class="fa fa-ban fa-2x"></i></span>
                                    <span class="fs-5">Wenig Möglichkeiten zur<br>individuellen Anpassung</span>
                                </li>
                                <li class="mb-4 d-flex align-items-center">
                                    <span class="icon-gradient-red me-3"><i class="fa fa-minus-circle fa-2x"></i></span>
                                    <span class="fs-5">Wichtige Infos fehlen<br><span class="text-secondary fs-6">(z. B. Social-Media-Links)</span></span>
                                </li>
                                <li class="mb-2 d-flex align-items-center">
                                    <span class="icon-gradient-red me-3"><i class="fa fa-money fa-2x"></i></span>
                                    <span class="fs-5">Unübersichtliche Preise<br><span class="text-secondary fs-6">und umständliche Bezahlung</span></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</app-parallax-section>